import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-merchant-services',
  templateUrl: './merchant-services.component.html',
  styleUrls: ['./merchant-services.component.scss']
})
export class MerchantServicesComponent implements OnInit {


  serviceForm!: FormGroup;


  services:any[] = [];
  categories:any[] = [];


  merchantId:any;
  merchantData:any;


  showAddForm:boolean=false;



  // Multiple media

  selectedFiles:any[]=[];

  previewFiles:any[]=[];



  // locations

  locations:string[]=[];

  locationInput:string="";



  // payment

  paymentType:string="FULL_PAYMENT";

  advanceAmount:number=0;



  imageBaseUrl =
  environment.apiUrl.replace('/api/v1.0','');





  constructor(
    private fb:FormBuilder,
    private apiService:ApiServiceService,
    private router:Router
  ){}




  ngOnInit():void{


    this.merchantId =
    localStorage.getItem('merchantId');

    const userStr = localStorage.getItem('user');
    if (userStr) {
      this.merchantData = JSON.parse(userStr);
    }

    this.createForm();


    this.loadServices();
    this.getCategories();


  }





  createForm(){


    this.serviceForm =
    this.fb.group({


      service_name:[
        '',
        Validators.required
      ],


      category:[
        '',
        Validators.required
      ],


      description:[
        ''
      ],


      price:[
        '',
        Validators.required
      ],


      duration:[
        ''
      ],


      included:[
        ''
      ]


    });


  }








  toggleAddForm(){


    this.showAddForm =
    !this.showAddForm;


  }









  selectFiles(event:any){
    const file = event.target.files[0];
    if(file){
      this.selectedFiles = [file];
      const reader = new FileReader();
      reader.onload=(e:any)=>{
        this.previewFiles = [{
          url:e.target.result,
          type: 'image'
        }];
      };
      reader.readAsDataURL(file);
    }
  }







  removeFile(index:number){


    this.selectedFiles.splice(
      index,
      1
    );


    this.previewFiles.splice(
      index,
      1
    );


  }









  addLocation(){


    const value =
    this.locationInput.trim();



    if(value){


      this.locations.push(value);


      this.locationInput="";


    }


  }







  removeLocation(index:number){


    this.locations.splice(
      index,
      1
    );


  }









  paymentChanged(){


    if(
      this.paymentType!=="ADVANCE"
    ){

      this.advanceAmount=0;

    }


  }









  addService(){



    if(this.serviceForm.invalid){


      this.serviceForm.markAllAsTouched();

      return;

    }






    const formData =
    new FormData();




    formData.append(
      "merchantId",
      this.merchantId
    );



    formData.append(
      "service_name",
      this.serviceForm.value.service_name
    );



    formData.append(
      "category",
      this.serviceForm.value.category
    );



    formData.append(
      "description",
      this.serviceForm.value.description
    );



    formData.append(
      "price",
      this.serviceForm.value.price
    );



    formData.append(
      "duration",
      this.serviceForm.value.duration
    );





    const includedArray =
    this.serviceForm.value.included
    ?
    this.serviceForm.value.included
    .split(',')
    .map((x:string)=>x.trim())
    .filter((x:string)=>x)
    :
    [];



    formData.append(
      "included",
      JSON.stringify(includedArray)
    );






    formData.append(
      "service_locations",
      JSON.stringify(this.locations)
    );







    formData.append(
      "payment",
      JSON.stringify({

        type:this.paymentType,

        advanceAmount:this.advanceAmount

      })
    );






    this.selectedFiles.forEach(
      file=>{


        formData.append(
          "media",
          file
        );


      }
    );








    this.apiService
    .addMerchantService(formData)
    .subscribe({



      next:(res)=>{


        Swal.fire({

          icon:'success',

          title:'Service Added',

          timer:1500,

          showConfirmButton:false

        });



        this.resetForm();


        this.showAddForm=false;


        this.loadServices();


      },



      error:(err)=>{
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Upgrade Required',
          text: err.error?.message || err.message || 'Error adding service'
        });
      }



    });




  }
  getCategories(){

  this.apiService
  .getServiceCategories()
  .subscribe({

    next:(res:any)=>{

      this.categories =
      res.data || [];

    },

    error:(err)=>{

      console.log(err);

    }

  });

}








  resetForm(){


    this.serviceForm.reset();


    this.selectedFiles=[];


    this.previewFiles=[];


    this.locations=[];


    this.locationInput="";


    this.paymentType="FULL_PAYMENT";


    this.advanceAmount=0;


  }









  loadServices(){


    this.apiService
    .getMerchantServices(this.merchantId)
    .subscribe({



      next:(res)=>{


        this.services =
        res.data || [];


      },



      error:(err)=>{


        console.log(err);


      }


    });


  }









  editService(id:string){


    this.router.navigate([

      '/merchant/service/edit',

      id

    ]);


  }









  deleteService(id:string){



    Swal.fire({


      title:'Delete service?',


      icon:'warning',


      showCancelButton:true,


      confirmButtonColor:'#B01E3E'


    })
    .then(result=>{


      if(result.isConfirmed){


        this.apiService
        .deleteMerchantService(id)
        .subscribe(()=>{


          this.loadServices();


        });


      }


    });



  }



}